import React, { useEffect } from 'react';
import {
    changeFirstNameAll,
    changeMiddleNameAll,
    changeLastNameAll,
    changeCredentialsAll,
    changePrimaryTitleAll,
    changeEmailAll,
    changeMainAll,
    changeCellAll,
    changePhoneLabel1All,
    changePhoneLabel2All,
    changePhoneOtherLabel1All,
    changePhoneOtherLabel2All,
    changeTitle2All,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP20T9 = React.memo((props) => {
    useEffect(() => {
        changeFirstNameAll(props.firstName);
    }, [props.firstName]);

    useEffect(() => {
        changeMiddleNameAll(props.middleName);
    }, [props.middleName]);

    useEffect(() => {
        changeLastNameAll(props.lastName);
    }, [props.lastName]);

    useEffect(() => {
        changeCredentialsAll(props.credentials);
    }, [props.credentials]);

    useEffect(() => {
        changePrimaryTitleAll(props.primaryTitle);
    }, [props.primaryTitle]);

    useEffect(() => {
        changeMainAll(props.main);
    }, [props.main]);

    useEffect(() => {
        changeCellAll(props.cell);
    }, [props.cell]);

    useEffect(() => {
        changeEmailAll(props.email);
    }, [props.email]);

    useEffect(() => {
        changePhoneLabel1All(props.phoneLabel1);
    }, [props.phoneLabel1]);

    useEffect(() => {
        changePhoneLabel2All(props.phoneLabel2);
    }, [props.phoneLabel2]);

    useEffect(() => {
        changePhoneOtherLabel1All(props.phoneOtherLabel1);
    }, [props.phoneOtherLabel1]);

    useEffect(() => {
        changePhoneOtherLabel2All(props.phoneOtherLabel2);
    }, [props.phoneOtherLabel2]);

    useEffect(() => {
        changeTitle2All(props.title2);
    }, [props.title2]);

    const handleSetPhoneLabel1 = (event) => {
        props.setPhoneLabel1(event.target.value);
    };

    const handleSetPhoneLabel2 = (event) => {
        props.setPhoneLabel2(event.target.value);
    };

    const handleSetPhoneOtherLabel1 = (event) => {
        props.setPhoneOtherLabel1(event.target.value);
    };

    const handleSetPhoneOtherLabel2 = (event) => {
        props.setPhoneOtherLabel2(event.target.value);
    };

    let phoneOtherLabel1Field = null;
    if (props.phoneLabel1 === 'Other') {
        phoneOtherLabel1Field = (
            <input type="text" className="other-label" placeholder="Enter name" value={props.phoneOtherLabel1} onChange={handleSetPhoneOtherLabel1} />
        );
    }

    let phoneOtherLabel2Field = null;
    if (props.phoneLabel2 === 'Other') {
        phoneOtherLabel2Field = (
            <input type="text" className="other-label" placeholder="Enter name" value={props.phoneOtherLabel2} onChange={handleSetPhoneOtherLabel2} />
        );
    }

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="First Name"
                value={props.firstName}
                setFunction={props.setFirstName}
                placeholder="Your First Name"
            />
            <TextField
                label="MI"
                value={props.middleName}
                setFunction={props.setMiddleName}
                placeholder="Your Middle Initial"
            />
            <TextField
                required
                label="Last Name"
                value={props.lastName}
                setFunction={props.setLastName}
                placeholder="Your Last Name"
            />
            <TextField
                label="Credentials"
                value={props.credentials}
                setFunction={props.setCredentials}
                placeholder="Your Credentials"
            />
            <hr />
            <TextField
                maxlength="75"
                label="Primary Title"
                value={props.primaryTitle}
                setFunction={props.setPrimaryTitle}
                placeholder="Employee or Faculty Position"
            />
            <TextField
                maxlength="75"
                label="Primary Title Line 2"
                value={props.title2}
                setFunction={props.setTitle2}
                placeholder="Employee or Faculty Position"
            />
            <hr />
            <TextField
                label="Email"
                value={props.email}
                setFunction={props.setEmail}
                placeholder="Your Email Address"
            />
            <div className="variable">
                <div className="label">
                    <select className="select-label" value={props.phoneLabel1} onChange={handleSetPhoneLabel1}>
                        <option value="Phone">Phone</option>
                        <option value="Office">Office</option>
                        <option value="Main">Main</option>
                        <option value="Direct">Direct</option>
                        <option value="Cell">Cell</option>
                        <option value="Fax">Fax</option>
                        <option value="Other">Other</option>
                    </select>
                    &nbsp;:
                    {phoneOtherLabel1Field}
                </div>
                <TextField
                    isPhone
                    showLabel={false}
                    phoneFormat={3}
                    label="Office"
                    value={props.main}
                    setFunction={props.setMain}
                    placeholder="Phone number"
                />
            </div>
            <div className="variable">
                <div className="label">
                    <select className="select-label" value={props.phoneLabel2} onChange={handleSetPhoneLabel2}>
                        <option value="Phone">Phone</option>
                        <option value="Office">Office</option>
                        <option value="Main">Main</option>
                        <option value="Direct">Direct</option>
                        <option value="Cell">Cell</option>
                        <option value="Fax">Fax</option>
                        <option value="Other">Other</option>
                    </select>
                    &nbsp;:
                    {phoneOtherLabel2Field}
                </div>
                <TextField
                    isPhone
                    showLabel={false}
                    phoneFormat={3}
                    label="Cell"
                    value={props.cell}
                    setFunction={props.setCell}
                    placeholder="Phone number"
                />
            </div>
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: 100, label: '1 bundle (100)' },
                    { value: 200, label: '2 bundles (200)' },
                    { value: 300, label: '3 bundles (300)' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UTHealth Houston | School of Public Health Pocket Card</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Flat: 3.5" x 6"</li>
                        <li>Stock: 100# Cougar Opaque White Cover</li>
                        <li>Printed: Color one side</li>
                        <li>Packaging: Bundles in 100's</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP20T9;
